import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDClickableText, FDContentContainer, FDDialog, FDDialogContent,
  FDEmphasisSurface, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorderRadius } from 'Components/utils';

const useStyles = buildUseStyles('PM2JourneyInvestingImageScreenLayout', (theme) => ({
  emphasisSurfaceWrapper: {
    width: '100%',
    // The images have a larger border radius than the emphasis surface we're placing them on, which leads to a weird visual effect.
    // To fix that, make the emphasis surface have more rounded corners, using !important to overwrite what FD is adding
    '& > *': {
      ...getBorderRadius(`${theme.radius.lg} !important`, { all: true }),
    },
  },
}));

export const PM2JourneyInvestingImageScreenLayout = () => {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogText, setDialogText] = React.useState('');
  const { resource } = useMetaLayoutContext();
  return (
    <FDContentContainer maxWidth="lg">
      <FDStack direction="column" spacing={3} paddingY={4}>
        <FDStack direction="column" spacing={4}>
          <MetaControlField attr="stepper" />
          <MetaControlField attr="title" />
          <MetaControlField attr="description" />
        </FDStack>
        <div className={classes.emphasisSurfaceWrapper} style={{ aspectRatio: resource.relationship(fr.relationships.image.name)?.meta('aspectRatio') }}>
          <FDEmphasisSurface>
            <ImageRel relationship={resource.relationship(fr.relationships.image.name)} fullScreenExpansionIconColor="white" />
          </FDEmphasisSurface>
        </div>
        <FDStack direction={'column'}>
          <Richtext richtext Component={FDBodyText} size={'sm'} align={'center'} color={'textDisabled'} value={resource.attr('disclaimer')} />
          {resource.attr('disclaimerLinkText')
            ? <FDBodyText
              size={'sm'}
              color={'textDisabled'}
              align={'center'}
              value={
                <FDClickableText
                  appearance={'standalone'}
                  label={resource.attr('disclaimerLinkText')}
                  onClick={() => { setDialogOpen(true); setDialogText(resource.attr('disclaimerLinkContent')); }}
                />
            }
            />
            : null}
        </FDStack>
        {
        dialogOpen ? (
          <FDDialog open={dialogOpen} onClose={() => setDialogOpen(false)} closeOnBackdropClick dialogWidth={'md'} noCloseButton={false}>
            <FDDialogContent>
              <Richtext richtext Component={FDBodyText} size={'md'} value={dialogText} />
            </FDDialogContent>
          </FDDialog>)
          : null
      }
      </FDStack>
    </FDContentContainer>
  );
};
